import React, { FC } from 'react'

import { DeclarationItemState, SimpleDeclaration } from '../../types'
import { ActionButtonProps } from '../ActionButton'
import { Icons } from '../Icon'

import * as SC from './styled'

export type DeclarationTableProps = {
  className?: string
  declarations: (SimpleDeclaration & {
    actions?: {
      modify?: ActionButtonProps
      delete?: ActionButtonProps
    }
    isEditing?: boolean
    editingForm?: React.ReactNode
  })[]
  numberHeaderLabel: string
  descriptionHeaderLabel: string
  stateHeaderLabel: string
  actionHeaderLabel: string
  refusedStateLabel: string
  validatedStateLabel: string
  pendingStateLabel: string
  editingStateLabel: string
}

const DeclarationTable: FC<DeclarationTableProps> = (props) => {
  const {
    className,
    declarations,
    numberHeaderLabel,
    descriptionHeaderLabel,
    stateHeaderLabel,
    actionHeaderLabel,
    refusedStateLabel,
    validatedStateLabel,
    pendingStateLabel,
    editingStateLabel,
  } = props

  const renderDeclarationState = (state: DeclarationItemState) => {
    return (
      <SC.DeclarationState>
        {state === DeclarationItemState.Refused
          ? refusedStateLabel
          : state === DeclarationItemState.Validated
            ? validatedStateLabel
            : pendingStateLabel}
        <SC.StyledIcon icon={Icons.check} />
      </SC.DeclarationState>
    )
  }

  return (
    <SC.Container className={className}>
      <SC.Table>
        <SC.TableHead>
          <SC.TableRow>
            <SC.TableHeader>{numberHeaderLabel}</SC.TableHeader>
            <SC.TableHeader>{descriptionHeaderLabel}</SC.TableHeader>
            <SC.TableHeader>{stateHeaderLabel}</SC.TableHeader>
            {declarations.some((declaration) => declaration.actions) && (
              <SC.TableHeader>{actionHeaderLabel}</SC.TableHeader>
            )}
          </SC.TableRow>
        </SC.TableHead>
        <SC.TableBody>
          {declarations.map((declaration, key) => (
            <React.Fragment key={key}>
              <SC.TableRow key={declaration.id} $isEditing={declaration.isEditing}>
                <SC.TableCell>{declaration.id}</SC.TableCell>
                <SC.TableCell>
                  <SC.Markdown text={declaration.description} />
                </SC.TableCell>
                <SC.TableCell>
                  {declaration.state && renderDeclarationState(declaration.state)}
                </SC.TableCell>
                {declaration.actions && !declaration.isEditing && (
                  <SC.TableCell>
                    <SC.Actions>
                      {declaration.actions.delete && (
                        <SC.Action {...declaration.actions.delete} type="button" />
                      )}
                      {declaration.actions.modify && (
                        <SC.Action {...declaration.actions.modify} type="button" />
                      )}
                    </SC.Actions>
                  </SC.TableCell>
                )}
                {declaration.isEditing && <SC.TableCell>{editingStateLabel}</SC.TableCell>}
              </SC.TableRow>
              {declaration.isEditing && declaration.editingForm && (
                <SC.TableRow>
                  <SC.TableCell colSpan={4} $noPadding>
                    <SC.EditingFormWrapper>{declaration.editingForm}</SC.EditingFormWrapper>
                  </SC.TableCell>
                </SC.TableRow>
              )}
            </React.Fragment>
          ))}
        </SC.TableBody>
      </SC.Table>
    </SC.Container>
  )
}

export default DeclarationTable
